import React from "react";
import { useReducer } from "react";
import { Button, Input, message } from "antd";
import { changeCaseCover, crawlBehance } from "../../api";
import "./index.less";

const initState = {
  value1: "",
  value2: "",
  value3: "",
  value4: "",
  value5: "",
  value6: "",
  value7: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "setData":
      return {
        ...state,
        ...action.data,
      };
  }
};

function CaseCover() {
  const [state, dispatch] = useReducer(reducer, initState);
  const onChange = (e) => {
    const value = e.target.value;
    const id = "value" + e.target.id;
    dispatch({
      type: "setData",
      data: {
        [id]: value,
      },
    });
  };
  const submit = async (type) => {
    if (type === 0) {
      if (state.value1.trim() === "") {
        return message.error("id 不能为空");
      }
      if (state.value2.trim() === "" && state.value3.trim() === "") {
        return message.error("地址和标题必须选填一项")
      }
      const data = {
        caseId: state.value1.trim(),
        cover: state.value2.trim(),
        titleOrigin: state.value3.trim(),
      };
      const result = await changeCaseCover(data);
      if (result?.error?.errorCode === "0") {
        message.success("修改成功");
      } else {
        message.error(result?.error?.errorMsg);
      }
      return;
    }
    if (state.value4.trim() === "" || state.value7.trim() === "") {
      return message.error("发布时间和url不能为空");
    }
    const data = {
      url: state.value4.trim(),
      subscribeName: state.value6.trim(),
      classifyName: state.value5.trim(),
      publishTime: state.value7.trim(),
    };
    const result = await crawlBehance(data);
    if (result?.error?.errorCode === "0") {
      message.success("开始爬取");
    } else {
      message.error(result?.error?.errorMsg);
    }
  };
  // 一键清空
  const resetAll = () => {
    dispatch({
      type: "setData",
      data: {
        value1: '',
        value2: '',
        value3: '',
      },
    });
  }
  return (
    <>
      <div className="caseCover">
        <Button className="caseCoverTitle">案例封面图</Button>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div className="caseCoverItem">
            <span>输入ID</span>
            <Input id="1" value={state.value1} onChange={onChange} />
          </div>
          <div className="caseCoverItem">
            <span>封面地址</span>
            <Input id="2" value={state.value2} onChange={onChange} />
          </div>
          <div className="caseCoverItem">
            <span>标题修改</span>
            <Input id="3" value={state.value3} onChange={onChange} />
          </div>
          <div className="bottomBtn">
            <Button onClick={() => submit(0)} className="caseCoverButton">
              提交
            </Button>
            <Button onClick={resetAll} className="caseCoverButton">
              一键清空
            </Button>
          </div>
        </div>
      </div>

    </>
  );
}

export default CaseCover;
